<!-- 横线分隔条 组件 -->

<template>
  <div class="cross-line"></div>
</template>

<script>
export default {
  components: {},
  data () {
    return {}
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="scss" scoped>

.cross-line {
  margin-left: -20px;
  width: calc(100%+20px);
  height: 3px;
  background-color: #ebebeb;
  // border-top: 1px solid rgba(7, 17, 27, 0.1);
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);
}
</style>


// WEBPACK FOOTER //
// src/components/cross-line.vue